import styled from 'styled-components'
import { defaultTheme } from '~/styles/themes'
import { DividerColors, DividerProps } from './Divider.type'

const colorMap: Record<DividerColors, string> = {
  lightGray: defaultTheme.colors.colorSupportLightGrey,
  mediumGray: defaultTheme.colors.colorSupportMediumGrey,
  gray: defaultTheme.colors.focusBorderColor
}

type DividerStyleProps = Pick<DividerProps, 'spacingClass' | 'heightClass'> & {
  $orientation: DividerProps['orientation']
  $color: DividerProps['color']
}

export const StyledDivider = styled.hr<DividerStyleProps>`
  display: block;
  margin: 0;
  padding: 0;
  border: none;
  height: auto;

  ${({ theme, $orientation, heightClass, $color }) =>
    $orientation === 'vertical'
      ? `
        border-left-style: solid;
        border-left-width: ${`${theme.divider.height[heightClass]}px` || '1px'};
        border-left-color: ${$color ? colorMap[$color] : colorMap.mediumGray};
      `
      : `
        border-top-style: solid;
        border-top-width: ${`${theme.divider.height[heightClass]}px` || '1px'};
        border-top-color: ${$color ? colorMap[$color] : colorMap.mediumGray};
      `};

  ${({ theme, $orientation, spacingClass }) =>
    $orientation === 'vertical'
      ? `
        margin-left: ${`${theme.divider.spacing[spacingClass].margin}px` || '8px'};
        margin-right: ${`${theme.divider.spacing[spacingClass].margin}px` || '8px'};
      `
      : `
        margin-top: ${`${theme.divider.spacing[spacingClass].margin}px` || '8px'};
        margin-bottom: ${`${theme.divider.spacing[spacingClass].margin}px` || '8px'};
      `};
`
